import { Paging } from "../../Components/Paging/paging";

class ContactSearch {

    constructor() {
        const isContactSearchPage = document.querySelector('.search-hero--contact-search') !== null;

        if (!isContactSearchPage)
            return;

        this.form = document.querySelector('.search-hero__form--contact-form');
        this.container = document.querySelector('#contact-search-result');
        this.searchInput = document.querySelector('.search-hero__input.search-hero__input--search');
        this.addEventListeners();
        this.setUpPagination();
        this.initializeChips();
        this.initializeClearButtons();
        this.setClearFilterButtonVisibility();
    }

    setClearFilterButtonVisibility() {
        const form = document.querySelector('.search-hero__form--contact-form');
        const button = document.querySelector('.contact-search__filter-clear-all');
        const toggleClass = 'contact-search__filter-clear-all--hidden';

        const formData = new FormData(form);
        const hasValue = Array.from(formData.values()).some(value => value && value !== 'all');

        button.classList.toggle(toggleClass, !hasValue);
    }

    addEventListeners() {
        const selects = [...this.form.querySelectorAll('select')];
        selects.forEach(element => {
            element.addEventListener("change", e => {
                this.form.requestSubmit();
            });
        });

        this.form.addEventListener("submit", e => {
            e.preventDefault();
            this.updateUrlParams();
            this.dataLayerPush();
            this.fetchData((result) => this.renderHits(result.hits));
        });

        this.form.querySelector("button[type=submit]").addEventListener("click", e => {
            if (e.pointerType) {
                window.scrollTo({ top: this.container.offsetTop });
            }
        });
    }

    dataLayerPush() {
        const value = this.searchInput.value?.trim();
        if (!value || this.searchInputValue === value) return;
        this.searchInputValue = value;
        const dataLayer = window.dataLayer || [];
        dataLayer.push({
            'event': 'searchVaraMedarbetare',
            'Search_term': this.searchInputValue
        });
    }

    initializeChips() {
        const chips = document.querySelector('.search-hero__chips');

        if (!chips) {
            return;
        }

        const radioButtons = [...chips.querySelectorAll('input[type=radio]')];
        const self = this;

        radioButtons.forEach((radioButton) => {
            radioButton.addEventListener(`click`, function (e) {
                radioButtons.forEach((r) => {
                    r.parentElement.classList.remove('search-hero__chip--selected');
                    r.parentElement.classList.add('search-hero__chip--inactive');
                    r.checked = false;
                });

                e.target.parentElement.classList.add('search-hero__chip--selected');
                e.target.parentElement.classList.remove('search-hero__chip--inactive');
                e.target.checked = true;

                self.updateUrlParams();
                self.fetchData((result) => self.renderHits(result.hits));
            });
        });
    }

    updateUrlParams(queryParam, value) {
        const formData = new FormData(this.form);
        const urlParams = new URLSearchParams();
        for (let [key, value] of formData.entries()) {
            urlParams.set(key, value);
        }
        const url = window.location.href.split("?")[0] + `?${urlParams.toString()}`;
        window.history.pushState("", "", url);
    }

    fetchData(callback) {
        const headers = {
            'pragma': 'no-cache',
            'cache-control': 'no-cache',
            'X-Requested-With': 'XMLHttpRequest'
        };

        if (this.container.classList.contains("contact-search--loading"))
            return;

        this.container.classList.toggle("contact-search--loading");
        this.removePreviousResult();
        this.addLoadingDots();

        fetch(window.location.pathname + window.location.search,
            {
                headers: headers,
                method: 'GET',
                credentials: 'include'
            })
            .then(resp => resp.json())
            .then(callback)
    }

    addLoadingDots() {
        const loadingContainer = document.createElement("div");
        const loadingDots = document.createElement("div");
        loadingContainer.classList.add("contact-search__loader");

        loadingDots.classList.add("loading-dots");
        for (let i = 0; i < 4; i++) {
            loadingDots.appendChild(document.createElement("div"));
        }
        loadingContainer.appendChild(loadingDots)
        this.container.appendChild(loadingContainer);
    }

    removeLoadingDots() {
        const loadingDots = this.container.querySelector(".contact-search__loader");
        loadingDots.remove();
    }

    removePreviousResult() {
        let childrenToRemove = [...this.container.querySelectorAll('.validation-error, p, .contact-search__seperator, .contact-search__batch')]
        childrenToRemove.forEach(elem => {
            elem.remove();
        });
    }

    initializeClearButtons() {
        const form = document.querySelector('.search-hero__form--contact-form');
        const clearButtons = [...document.querySelectorAll('button[data-contactfilterclear]')];

        clearButtons.forEach((clearButton) => {
            clearButton.addEventListener(`click`, function () {
                clearButton.dataset.contactfilterclear.split(',').forEach((formElementName) => {
                    const formElement = form.querySelector(`[name="${formElementName}"]`);
                    if (formElement) {
                        formElement.value = '';
                    }
                });

                const allChipRadioButton = document.querySelector('.search-hero__chip-radio#all');
                allChipRadioButton.dispatchEvent(new Event('click')); // Will trigger the form to submit

            });
        });
    }

    renderHits(result) {
        this.container.classList.toggle("contact-search--loading");
        this.removeLoadingDots();
        this.container.innerHTML = result;
        this.initializeClearButtons();
        this.setClearFilterButtonVisibility();
    }

    setUpPagination() {
        const settings = {
            beforeSend: () => {
                this.container.classList.toggle("contact-search--loading");
                this.removePreviousResult();
                this.addLoadingDots();
            },
            callBackFn: (result) => this.renderHits(result.hits)
        }
        this.pagination = new Paging(settings);
    }
}


document.addEventListener("DOMContentLoaded", () => new ContactSearch());
